<script>
import { Download } from "@/mixins/download";

/**
 * File Uploads component
 */
export default {
  mixins: [Download],
  props: [
    "dialog",
    "closeModal",
    "modalTitle",
    "modalNote",
    "uploadSuccess",
    "downloadTemplate",
    "errors",
  ],
  data() {
    return {};
  },
};
</script>

<template>
  <v-dialog
    class="relative"
    v-model="dialog"
    max-width="650"
    @input="$emit('close')"
  >
    <div>
      <button class="close-btn" @click="$emit('close')">
        <v-icon size="22" class="mb-1 ml-1">$vuetify.icons.closeIcon</v-icon>
      </button>
    </div>
    <div class="card mb-0 pt-5">
      <slot />
    </div>
  </v-dialog>
</template>
<style>
.v-dialog {
  position: relative !important;
}
.close-btn {
  display: inline-block;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 9;
}
</style>
